import React, { useEffect, useState } from "react";
import TopHeader from "../Dashoboard/TopHeader";
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { saveLoader } from "../../redux/slice/loaderNoti";
import moment from "moment/moment";
import { useLazyShowRoomQuery } from "../../redux/api/api";
import ProductZoom from "../../components/ProductZoom";

const RoomView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [details, setDetails] = useState({});

  // RTK QUERY
  const [showRoomApi] = useLazyShowRoomQuery();

  const getDetatils = () => {
    dispatch(saveLoader(true));
    showRoomApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setDetails(res?.room);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getDetatils();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"room-view"} />
      <div className=" block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="user-detail-table">
              <table className="tabledetails table-borderless user-det w-100 mb-5">
                <thead>
                  <th colspan="3" className="h8 mb-0 font-weight-light p-3">
                    BASIC DETAILS
                  </th>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ width: "40%" }}>Room Category</td>
                    <td>:</td>
                    <td>{details?.category?.name}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Room Name</td>
                    <td>:</td>
                    <td>{details?.room_name}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Total Rooms</td>
                    <td>:</td>
                    <td>{details?.total_rooms}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Amenities</td>
                    <td>:</td>
                    <td className="amenity-type">
                      <ul>
                        {details?.amenities?.map((item, ind) => {
                          return (
                            <li key={ind}>
                              <img src={item?.amenity?.image} />
                              {item?.amenity?.name}
                            </li>
                          );
                        })}
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Total Rooms</td>
                    <td>:</td>
                    <td>{details?.total_rooms}</td>
                  </tr>
                  <tr class="bg-purple p-2 rounded my-2">
                    <td colspan="3" class="h8_2 mb-0 font-weight-light p-3">
                      Time Slots
                    </td>
                  </tr>

                  {details?.timeslots?.map((timez) => {
                    return (
                      <>
                        <tr>
                          <td style={{ width: "40%" }}>Slot Name</td>
                          <td>:</td>
                          <td>{timez?.timeslot?.name}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "40%" }}>Start Time</td>
                          <td>:</td>
                          <td>{timez?.timeslot?.start_time}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "40%" }}>Slot Hours</td>
                          <td>:</td>
                          <td>{timez?.timeslot?.type}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "40%" }}>Base Price</td>
                          <td>:</td>
                          <td>{timez?.total_price}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "40%" }}>Extra Person Charge</td>
                          <td>:</td>
                          <td>{timez?.extra_person_charge}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "40%" }}>Admin Commission</td>
                          <td>:</td>
                          <td>{timez?.admin_commission}</td>
                        </tr>
                      </>
                    );
                  })}

                  <tr class="bg-purple p-2 rounded my-2">
                    <td colspan="3" class="h8_2 mb-0 font-weight-light p-3">
                      Guest
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Minimum Adult</td>
                    <td>:</td>
                    <td>{details?.min_persons}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Maximum Adult</td>
                    <td>:</td>
                    <td>{details?.max_persons}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Minimum Child</td>
                    <td>:</td>
                    <td>{details?.min_childrens}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Maximum Child</td>
                    <td>:</td>
                    <td>{details?.max_childrens}</td>
                  </tr>
                  <tr class="bg-purple p-2 rounded my-2">
                    <td colspan="3" class="h8_2 mb-0 font-weight-light p-3">
                      Images
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="d-flex gap-3 mb-5">
              <div className="col-md-4 mx-3">
                {details?.images?.map((item, ind) => {
                  return (
                    <div key={ind} className={"mt-2"}>
                      <ProductZoom image_url={item?.image} />
                    </div>
                  );
                })}
              </div>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default RoomView;
